import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { isAlertSuspended, isEditOrResumeEnabled } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { dataAlertResume } from '../actions/menuActions/DataAlertMenuActions';
import { IDataAlertInfo } from '../models/IDataAlertInfo';

export const DataAlertResumeAction: IEntityAction<IDataAlertInfo, {}> = {
  name: EntityActionNames.Resume,
  translateName: Messages.resumeDataAlert_action,
  isVisible: (targetItems: IDataAlertInfo[]) => {
    return isAlertSuspended(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IDataAlertInfo[], state: AppState) => {
    return isEditOrResumeEnabled(state, targetItems);
  },
  createReduxAction: (targetItems: IDataAlertInfo[]) => dataAlertResume(targetItems)
};
